import { jsxs as m, Fragment as v, jsx as n } from "react/jsx-runtime";
import { clsx as s } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { remCalc as D } from "../../style/base/index.js";
import { RocheUIIcon as j } from "../icon/roche-icon.js";
import t from "./roche-button.module.scss.js";
import { RocheUIButtonAppearance as o, RocheUIButtonAlignment as S, RocheUIButtonSize as A, RocheUIButtonType as k, RocheUIButtonTarget as w } from "./roche-button-types.js";
const z = 24, G = 16, H = "loading", K = ({
  appearance: e = o.PRIMARY,
  alignment: p = S.CENTER,
  size: b = A.LARGE,
  disabled: i,
  download: U,
  text: d,
  visuallyHiddenText: h,
  type: B = k.BUTTON,
  target: T = w.SELF,
  leftIcon: R,
  rightIcon: _,
  href: I,
  hasMarginTop: g = !0,
  isDecorative: N = !1,
  isModalTrigger: y,
  isLoading: r,
  slot: L,
  onModalTrigger: C,
  onClick: E,
  ...f
}) => {
  const u = (c, F) => {
    const M = s(t["button__icon-container"], F && t["button__icon-container--loading"]), Y = b === A.SMALL ? G : z;
    return (
      // There's always text in the button, the icons are decorative: aria-hidden={true}
      /* @__PURE__ */ n("div", { className: M, "aria-hidden": !0, children: /* @__PURE__ */ n(j, { icon: c, height: `${D(Y)}rem` }) })
    );
  }, l = s(
    t.button,
    t[`button--size-${b}`],
    i && t["button--disabled"],
    r && t["button--loading"],
    p === S.LEFT && t["button--left-aligned"],
    e === o.PRIMARY && t["button--primary"],
    e === o.SECONDARY && t["button--secondary"],
    e === o.TERTIARY && t["button--tertiary"],
    e === o.SUCCESS && t["button--success"],
    e === o.ERROR && t["button--error"],
    e === o.BOTTOM_FIXED && t["button--bottom-fixed"]
  ), O = (c) => {
    y && C && (c.preventDefault(), C()), E && E(c);
  }, a = /* @__PURE__ */ m(v, { children: [
    /* @__PURE__ */ m("span", { className: s(t.button__content, r && t["button__content--loading"]), children: [
      R && u(R),
      /* @__PURE__ */ m("div", { className: t.button__text, "data-content": d, children: [
        d,
        !N && h && /* @__PURE__ */ n("span", { className: t["button__visually-hidden"], children: h })
      ] }),
      _ && u(_)
    ] }),
    r && /* @__PURE__ */ n("span", { className: t["button__loading-spinner"], children: u(H, r) })
  ] }), x = () => N ? /* @__PURE__ */ n("div", { className: l, children: a }) : I ? /* @__PURE__ */ n(
    "a",
    {
      className: l,
      onClick: O,
      href: i ? void 0 : I,
      target: T,
      download: U,
      ...f,
      children: a
    }
  ) : /* @__PURE__ */ n(
    "button",
    {
      className: l,
      onClick: O,
      type: B,
      disabled: i,
      ...f,
      children: a
    }
  );
  return /* @__PURE__ */ n("div", { className: s(t["button-wrapper"], !g && t["button-wrapper--no-margin"]), slot: L, children: x() });
};
export {
  K as RocheUIButton
};
